import type {
  CellData,
  ColumnDef,
  RowData,
  TableFeatures,
} from '@tanstack/react-table';

import { DATA_TABLE_ROW_DRAG_COLUMN_ID } from '../../constants.js';

/**
 * Helper function to identify the row drag column.
 * @internal
 */
export function isRowDragColumnDef<
  TFeatures extends TableFeatures,
  TData extends RowData,
  TValue extends CellData = CellData,
>(column: ColumnDef<TFeatures, TData, TValue>): boolean {
  return column.id === DATA_TABLE_ROW_DRAG_COLUMN_ID;
}
